import type { OutcomeState } from '../states/entities/outcomes';
import { type ObjectValuesUnionType } from '../utils/typing';

type TrackerType = {
  playerSrId: number;
  playerTeam: 1 | 2;
  matchId: number;
};

export type BetGroupOutcome = {
  matchId?: number | null;
  betId?: number | null;
  id?: number | null;
  marketId?: number | null;
  specialBetValue?: string;
  playerTrackerInfos?: TrackerType;
  starter?: boolean | null;
  disableDivider: boolean;
};

export type BetGroupPlayer = BetGroupOutcome & {
  flag?: string;
  label: string | null;
  playerFlag: string | null;
  subLabel: string | null;
  team: number | null;
  starter: boolean | null;
  outcomes: Array<BetGroupOutcome>;
  showPercentDistribution?: boolean;
  playerTrackerInfos?: TrackerType;
};

export type BetGroupEntity = {
  items: Array<BetGroupPlayer>;
  nbLines: number;
  expandPreviewLines?: number;
  showPercentDistribution?: boolean;
  groupLabel?: string;
  teamId?: number;
  flag?: string;
};

export type BetGroups = Array<BetGroupEntity>;

export const LabelConfigurations = Object.freeze({
  NO_LABEL: 'NO_LABEL',
  INSIDE_BUTTON: 'INSIDE_BUTTON',
  OUTSIDE_BUTTON: 'OUTSIDE_BUTTON',
});

export type LabelConfiguration = ObjectValuesUnionType<typeof LabelConfigurations>;

export type OutcomeStateWithValue = OutcomeState & {
  value: number;
};

export const PresentationModes = Object.freeze({
  CLASSIC: 'CLASSIC',
  SLIDER_BY_BET: 'SLIDER_BY_BET',
  SLIDER_BY_OUTCOME: 'SLIDER_BY_OUTCOME',
});

export type PresentationMode = ObjectValuesUnionType<typeof PresentationModes>;

export const PresentationDefaultPositions = Object.freeze({
  START: 'start',
  MIDDLE: 'middle',
});

export type PresentationDefaultPosition = ObjectValuesUnionType<typeof PresentationDefaultPositions>;

export type PresentationItem = {
  type: PresentationMode;
  labelSpecifier?: string;
  defaultPosition?: PresentationDefaultPosition;
  disableExpand?: boolean;
};
